module.exports = __webpack_public_path__ + "static/img/file-excl.e3e73094.svg";